import builder from '../builder';
import SingleNeutralCheck from '../../streamline-icons/light/single-neutral-check.svg';

export default builder('IconSingleNeutralCheckLight', SingleNeutralCheck);
